/**
 * Concept Archetype
 * 
 * @Version 1.0
 * @Author Daniel Lepe
 */

import _ from 'lodash'

const baseController = 'usuarios',
    baseIndex = baseController + '/index',
    archetype = [
        {
            key: "id_pk",
            type: 'hidden', // [hidden|number|price|phone|textarea|positivo|password|email]
        },
        {
            key: "revVersion", // COTEJADO AUTOMÁTICAMENTE PARA EVITAR SOBREESCRITURA.
            type: 'hidden', // [hidden|number|price|phone|textarea|positivo|password|email]
        },
        {
            key: "clientedatos",
            type: 'hidden'
        },
        {
            key: "clientefacturacion",
            type: 'hidden'
        },
        {
            key: 'nutricion_comentarios',
            type: 'hidden'
        },
        [{
            key: "imagen",
            type: 'imageurl' // STORAGE IMG 
        }],
        null,
        [
            {
                key: "nombre",
            },
            {
                key: "apellidos",
            }
        ],
        [
            {
                key: "usuario",
                readonly: true,
            },
            {
                key: "contrasena",
                // type: "password",
                label: 'Contraseña'
            }
        ],
        [{
            key: "correo_electronico",
            label: 'Correo electrónico',
            readonly: true
        }],
        null,
        [
            {
                key: "tipoUsuario",
                label: 'Tipo de usuario',
                type: 'select',
                options: ['Normal', 'Restaurant', 'Admin']
            },
        ],
        null,
        [
            { key: 'codigo_registro', label: 'Código de registro' }
        ],
        [
            {
                key: "membresia",
                label: 'Membresía',
                type: 'select',
                options: ['Normal', 'VIP']
            },
            {
                key: "vigenciaVIP",
                label: 'Vigencia',
                type: 'date',
            }
        ],
        [
            {
                key: "paypalSuscriptionID",
                label: 'Paypal® ID',
                readonly: true
            },
            {
                key: "paypalSuscriptionSTATUS",
                label: 'Estatus de suscripción',
                readonly: true
            }
        ],
        null,
        [{
            key: "admin_cocina",
            label: 'Cocinero',
            type: 'checkbox',
        }],
        [{
            key: "admin_cocina_costohora",
            label: 'Costo por hora',
            type: 'price',
        }],
        null,
        [{
            key: "reproducirJingleAlInicio",
            label: 'Reproducción inicial de Jingle',
            type: 'checkbox'
        }],
        {
            key: 'nutriusuariosCfg',
            type: 'hidden'
        }
    ],
    archetypeNutriusuarios = () => {
        return [
            {
                key: 'id',
                type: 'hidden'
            },
            {
                key: 'usuarios_id_pk',
                type: 'hidden'
            },
            {
                key: 'horas',
                type: 'select',
                options: ['Desayuno', 'Colación', 'Comida', 'Cena']
            },
            {
                key: 'equivalencias_id',
                label: 'Alimento',
                type: 'select'
            },
            {
                key: 'cantidad',
                type: 'positive'
            },
            {
                key: 'comentarios',
                type: 'hidden'
            },
            {
                key: 'created',
                type: 'hidden'
            },
            {
                key: 'modified',
                type: 'hidden'
            }
        ]
    },
    archetypeClientedatos = {
        id_pk: null,
        fechanacimiento: null,
        telefono: null,
        fechaingreso: null,
        telefonomovil: null,
        telefonooficina: null,
        calle: null,
        numero: null,
        idestado_fk: null,
        ciudad: null,
        colonia: null,
        codigopostal: null,
        miembrosfamilia: null,
        miembrosmenores: null,
        detalles: null,
        idusuario_fk: null,
        id_ultimo_usuario_fk: null,
        ultima_actualizacion: null,
        surtir: null,
        surtirart: null,
        diaentrega: null,
        horaentrega1: null,
        horaentrega2: null,
    },
    captions = [
        { key: 'imagen', label: ' ' },
        { key: 'nombreCompleto', label: 'Cliente' },
        { key: 'correo_electronico', label: 'E-mail' },
        { key: 'membresia' },
        { key: 'monedero' },
        { key: 'codigo_registro', label: 'Código de registro' },
        { key: '_' },
    ];

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    // console.log("isNil", _.isNil(conceptId))
    return str;
}


export {
    archetype,
    captions,
    baseIndex,
    automodalHandler,
    archetypeNutriusuarios,
    archetypeClientedatos
}